(() => {
  const selected = new Map();
  const root = document.querySelector('.ct-home');
  const labels = root ? JSON.parse(root.querySelector('[data-ct-labels]').textContent) : {};
  const initialize = (scope) => {
    scope.querySelectorAll('[data-ct-carousel]').forEach((track) => {
      if (track.dataset.ctReady) return;
      track.dataset.ctReady = 'true';
      const previous = document.querySelector(`[data-ct-prev="${track.id}"]`);
      const next = document.querySelector(`[data-ct-next="${track.id}"]`);
      const progress = document.querySelector(`[data-ct-progress="${track.id}"]`);
      const step = () => track.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
      const update = () => {
        const overflow = track.scrollWidth - track.clientWidth;
        if (previous) previous.disabled = track.scrollLeft < 3;
        if (next) next.disabled = track.scrollLeft > overflow - 3;
        if (progress) progress.textContent = `${Math.min(track.children.length,Math.round(track.scrollLeft / step()) + 1)} / ${track.children.length}`;
        if (previous) previous.parentElement.hidden = overflow < 3;
      };
      const behavior = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
      previous?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: behavior() }));
      next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: behavior() }));
      track.addEventListener('scroll', update, { passive:true });
      new ResizeObserver(update).observe(track);
      update();
    });
    scope.querySelectorAll('[data-ct-video]').forEach((frame) => {
      const cover = frame.querySelector('button');
      const video = frame.querySelector('video');
      if (!video || cover.dataset.ctReady) return;
      cover.dataset.ctReady = 'true';
      cover.addEventListener('click', () => {
        const source = video.querySelector('source');
        if (!source.src) { source.src = source.dataset.ctSource; video.load(); }
        cover.hidden = true;
        video.play().catch(() => { cover.hidden = false; });
      });
    });
    if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      }), { threshold:.05, rootMargin:'0px 0px -20px 0px' });
      scope.querySelectorAll('.ct-reveal').forEach((element) => { element.classList.add('is-ready'); observer.observe(element); });
    }
  };
  const dropdowns = [...document.querySelectorAll('[data-ct-dropdown]')];
  dropdowns.forEach((details) => {
    details.addEventListener('toggle', () => { if (details.open) dropdowns.forEach((other) => { if (other !== details) other.open = false; }); });
    if (details.closest('.ct-nav')) {
      let timer;
      details.querySelector('summary').addEventListener('click', (event) => {
        if (event.detail > 0 && matchMedia('(hover: hover)').matches) { event.preventDefault(); details.open = true; }
      });
      details.addEventListener('pointerenter', (event) => { if (event.pointerType !== 'mouse') return; clearTimeout(timer); details.open = true; });
      details.addEventListener('pointerleave', (event) => { if (event.pointerType !== 'mouse') return; timer = setTimeout(() => { if (!details.contains(document.activeElement)) details.open = false; },180); });
    }
  });
  document.addEventListener('click', (event) => dropdowns.forEach((details) => { if (!details.contains(event.target)) details.open = false; }));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') dropdowns.forEach((details) => { if (details.open) { details.open = false; details.querySelector('summary').focus(); } }); });
  if (root) {
    const bar = root.querySelector('[data-ct-compare-bar]');
    const counter = root.querySelector('[data-ct-compare-count]');
    const dialog = root.querySelector('[data-ct-compare-dialog]');
    const tableContainer = root.querySelector('[data-ct-compare-table]');
    const boxes = [...root.querySelectorAll('[data-ct-compare]')];
    const updateBar = () => {
      bar.hidden = !selected.size;
      counter.textContent = `${selected.size} ${labels.selected}`;
      boxes.forEach((box) => { box.checked = selected.has(box.dataset.ctCompare); });
    };
    boxes.forEach((box) => box.addEventListener('change', () => {
      const id = box.dataset.ctCompare;
      if (box.checked) {
        if (selected.size === 3 && !selected.has(id)) { box.checked = false; counter.textContent = labels.limit; return; }
        selected.set(id,{ ...box.dataset });
      } else selected.delete(id);
      updateBar();
    }));
    root.querySelector('[data-ct-clear-compare]').addEventListener('click', () => { selected.clear(); updateBar(); });
    root.querySelector('[data-ct-open-compare]').addEventListener('click', () => {
      tableContainer.replaceChildren();
      const table = document.createElement('table');
      const data = [...selected.values()];
      [[labels.model,'title'],[labels.price,'price'],[labels.battery,'battery'],[labels.height,'height']].forEach(([name,key],index) => {
        const row = document.createElement('tr');
        const heading = document.createElement('th'); heading.scope = 'row'; heading.textContent = name; row.append(heading);
        data.forEach((item) => {
          const cell = document.createElement('td');
          if (index === 0) {
            const image = document.createElement('img'); image.src = item.image; image.alt = item.title; cell.append(image);
            const title = document.createElement('p'); title.textContent = item.title; cell.append(title);
            const link = document.createElement('a'); link.href = item.url; link.className = 'ct-button'; link.textContent = labels.view; cell.append(link);
          } else cell.textContent = item[key] || labels.confirm;
          row.append(cell);
        });
        table.append(row);
      });
      tableContainer.append(table);
      dialog.showModal();
    });
    root.querySelector('[data-ct-close-compare]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
